/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from '../../icetypes';
import { basecodereference } from 'projects/icemedx-lib/src/models/ehr/subs/basecodereference';

export class subtypereference extends IceEntity {
  sub_type_reference_key: string = "";
  sub_type: number = 0;
  alternate_quantity_label: string = "";
  auto_transcription: string = "";
  type_of_range: number = 0;
  type_lower_limit: string = "";
  type_upper_limit: string = "";
  type_unit_code: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;
  contraindication: boolean = false;
  interaction: boolean = false;
  synonym: boolean = false;
  required: boolean = false;
  src_type: IceTypes.SourceType = IceTypes.SourceType.srcUndefined;

  CODES: basecodereference[] = [];

  gettablename(): string {
    return "SUB_TYPE_REFERENCE";
  }

  hassubtree(ColumnName): boolean {
    if (ColumnName.Length == 0) return false;
    else if (ColumnName == "CODES") return true;

    return false;
  }

  getsubtreetablename(ColumnName): string {
    if (ColumnName.Length == 0) return null;
    else if (ColumnName == "CODES") return "BASE_CODE_REFERENCE";

    return null;
  }
}
